export const apiConstants = {

    // Common variables

    LOGIN_BY : 'manual',

    DEVICE_TYPE : 'web',

    DEVICE_TOKEN : '123456',

    // Song download status

    DOWNLOAD_INITIATE_STAUTS : 1,

    DOWNLOAD_PROGRESSING_STAUTS : 2,

    DOWNLOAD_PAUSE_STAUTS : 3,

    DOWNLOAD_COMPLETE_STAUTS : 4,

    DOWNLOAD_CANCEL_STAUTS : 5,

    // Wishlist status

    WISHLIST_CLEAR_ALL : 1,

    WISHLIST_CLEAR_SINGLE_AUDIO : 0,

    // History status

    HISTORY_CLEAR_ALL : 1,

    HISTORY_CLEAR_SINGLE_AUDIO : 0,

    // PAGE TYPES

    PRIVACY_PAGE_TYPE : 'privacy',

    TERMS_PAGE_TYPE : 'terms',

    ABOUT_PAGE_TYPE : 'about',

    HELP_PAGE_TYPE : 'help',

    CONTACT_PAGE_TYPE : 'contact',

    // Social Login Credentials

    GOOGLE_CLIENT_ID :  "603748490991-lta5s2ju9krs16uvq0thb2f5rjohpqbd.apps.googleusercontent.com",

    FACEBOOK_APP_ID : "285371778766319",

    JWPLAYER_KEY : "M2NCefPoiiKsaVB8nTttvMBxfb1J3Xl7PDXSaw==",

    // Hisotry status

    HISTORY_INITIATE_STATUS : 1,

    HISTORY_COMPLETE_STATUS : 2,

    HISTORY_DELETE_STATUS : 3,

    settingsUrl: "https://cms-umusic.aiocdemos.com/api/get_settings_json",
}
